import { Injectable } from '@angular/core';
import { ModalService } from 'src/app/modules/modal/modal.service';
import { DidSolveIssueComponent } from '../../surveys/did-solve-issue/did-solve-issue.component';
import { SurveyPositiveModal } from '../common/survey-positive-modal/survey-positive-modal.component';
import { SurveyNegativeModal } from '../common/survey-negative-modal/survey-negative-modal.component';
import { SurveyService } from '@core/services/survey.service';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SuccessSurveyComponent } from '../../surveys/success-survey/success-survey.component';

@Injectable({
  providedIn: 'root'
})
export class FeedBackService {
  constructor(private modalService: ModalService, private surveyBuilderService: SurveyService) {}

  start(): Observable<any> {
    return this.surveyBuilderService.getBuilderData().pipe(
      switchMap((data: any) => {
        return this.openSuveyModal(data.question).pipe(
          switchMap(([result, ref]) => {
            ref.hide();
            if (result === 'like') {
              return this.openPositiveSuveyModal(data.id, data.positive);
            }
            return this.openNegativeSuveyModal(data.id, data.negative, data.options, data.answerType);
          }),
          switchMap(([value, ref]) => {
            ref.hide();
            localStorage.setItem('feedBackIsCompleted', 'yes');
            return this.surveyBuilderService.saveCustomerSurvey(value).pipe(switchMap(() => of(value)));
          }),
          filter(value => value.isCompleted),
          switchMap(() => this.openThxSuveyModal())
        );
      })
    );
  }

  openSuveyModal(questionTitle: string) {
    return this.modalService.openModal<any, any>(
      DidSolveIssueComponent,
      {
        componentData: {
          questionTitle
        },
        modalOptions: {
          class: 'width-400 mt-120'
        }
      },
      false
    );
  }

  openPositiveSuveyModal(id, questionTitle) {
    return this.modalService.openModal<any, any>(
      SurveyPositiveModal,
      {
        componentData: {
          id,
          questionTitle
        },
        modalOptions: {
          class: 'width-400'
        }
      },
      false
    );
  }

  openNegativeSuveyModal(id, questionTitle, options, answerType) {
    return this.modalService.openModal<any, any>(
      SurveyNegativeModal,
      {
        componentData: {
          id,
          questionTitle,
          options,
          answerType
        },
        modalOptions: {
          class: 'width-400'
        }
      },
      false
    );
  }

  openThxSuveyModal() {
    return this.modalService.openModal<any, any>(
      SuccessSurveyComponent,
      {
        componentData: {},
        modalOptions: {
          class: 'width-400'
        }
      },
      false
    );
  }
}
